import Store from '@copilot/common/store/storeClass';

export default Store;
